import React, { Component } from 'react'
import logo from '../../SFImages/logo.png';
import SFlogo from '../../SFImages/SFLogo.png';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Button, Card, CardHeader, CardContent, Grid, Container, Stack, Tabs, Tab, CircularProgress, Box, Alert, InputAdornment, IconButton } from '@mui/material';
import { AppProperties, handleLoginToken, Logout, isInvalid } from '../../../common/functions';
import { toast } from 'react-toastify';
import validate from 'validate.js';
import './style.css'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { isMobile, isBrowser } from 'react-device-detect';
import PasswordListItem from './components/PasswordListItem';
import { BeatLoader } from 'react-spinners';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { NotificationManager } from 'react-notifications';

validate.validators.emailDomain = function (value, options, key, attributes) {
    if (value && value.indexOf('@') !== -1) {
        const [, domain] = value.split('@');
        const domains = options.domains || [];
        const whitelistedEmails = options.whitelistedEmails || [];

        // console.debug("value", value, domains, options, whitelistedEmails)
        if (whitelistedEmails.includes(value.toLowerCase())) {
            return;
        }

        if (!domains.includes(domain.toLowerCase())) {
            return options.message || '^Please use a valid email address';
        }
    }
};

validate.validators.passwordComplexity = function (value, options, key, attributes) {
    const minLength = options.minLength || 8;
    const hasNumber = /\d/.test(value);
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value);

    if (!value || value.length < minLength || !hasNumber || !hasUpperCase || !hasLowerCase || !hasSpecialChar) {
        return "Please enter a valid password";
    }
};


class SFAuth extends Component {

    appProperties = AppProperties();

    defaultMessage = {
        show: false,
        type: '', // error, warning, success
        msg: '' // real message
    }

    constructor(props) {
        super(props)

        this.state = {
            authType: 'login',
            loading: false,
            ltiLoginLoading: false,

            forgotPasswordLoading: false,
            requestLoading: false,

            // Password Login states
            emailID: '',
            password: '',

            // One Time Code States
            code: '',
            haveCode: false,
            registeredCode:false,

            // Register states
            firstName: '',
            lastName: '',
            password1: '',
            password2: '',
            confirmationEmailID: '',
            passwordLoginFieldErrors: null,
            requestCodeFieldErrors: null,
            registerFieldErrors: null,

            // Message
            message: this.defaultMessage,
            showPassword: false,
            showPassword1: false,
            showPassword2: false,
            showMoreMobile:false,

            // password check list
            passwordConditions: {
                minLength: false,
                hasNumber: false,
                hasUpperCase: false,
                hasLowerCase: false,
                hasSpecialChar: false,
            },
            showPassword1Checklist: false,

            passwordMatching: false,
            showPassword2Checklist: false,
        }
    }

    componentDidMount() {
        //IMPORTANT: DO NOT REMOVE THE BELOW CODE
        // The below code is used to auto login the LTI students
        const queryParams = new URLSearchParams(window.location.search);
        let token = queryParams.get('token')
        let ltiUserID = queryParams.get('ltiUserID')

        if (token && token !== "") {
            this.setState({
                ltiLoginLoading: true,
            })
            const [encodedHeader, encodedPayload, signature] = token.split('.');
            let decodedPayload;
            try {
                decodedPayload = JSON.parse(atob(encodedPayload));
            } catch (error) {
                console.error(error);
                NotificationManager.error("Unable to parse token", "Error", 6000);
                this.setState({
                    ltiLoginLoading: false,
                })
                return;
            }
            if (decodedPayload) {
                //logout existing user
                Logout();
                console.debug("decodedPayload", decodedPayload, this.appProperties);
                window.localStorage.setItem("isLTIStudent", decodedPayload.isLTIStudent);
                this.appProperties.currentUserData.setUserDetails(decodedPayload, this.appProperties.loginType);
                // Remove the token once it's been used
                if (queryParams.has('token')) {
                    queryParams.delete('token');
                    const newSearch = queryParams.toString();
                    const newPath = `${window.location.pathname}?${newSearch}`;

                    const encodedPath = encodeURI(newPath);

                    console.debug("encodedPath", encodedPath)

                    window.history.replaceState(null, '', encodedPath);
                    window.location.reload();
                } else {
                    this.setState({
                        ltiLoginLoading: false,
                    })
                }
            }
        }
        //IMPORTANT: DO NOT REMOVE THE ABOVE CODE
    }

    passwordLoginSchema = {
        emailID: {
            presence: {
                allowEmpty: false,
                message: '^Please enter email ID'
            },
            email: true,
            ...(this.appProperties.mailDomain !== "any" && { // if all emails not allowed, validate email by checking mail domain and whitelisted emails
                emailDomain: {
                    message: '^Please use a valid ' + this.appProperties.mailDomain.split(";") + ' email address',
                    domains: this.appProperties.mailDomain.split(";"),
                    whitelistedEmails: [...this.props.whitelist],
                }
            })
        },
        password: {
            presence: {
                allowEmpty: false,
                message: '^Please enter a password'
            },
        },
    }

    requestCodeSchema = {
        emailID: {
            presence: {
                allowEmpty: false,
                message: '^Please enter email ID'
            },
            email: true,
            ...(this.appProperties.mailDomain !== "any" && { // if all emails not allowed, validate email by checking mail domain and whitelisted emails
                emailDomain: {
                    message: '^Please use a valid ' + this.appProperties.mailDomain.split(";") + ' email address',
                    domains: this.appProperties.mailDomain.split(";"),
                    whitelistedEmails: [...this.props.whitelist],
                }
            })
        },
    }

    registerSchema = {
        emailID: {
            presence: {
                allowEmpty: false,
                message: '^Please enter email ID'
            },
            email: true,
            ...(this.appProperties.mailDomain !== "any" && { // if all emails not allowed, validate email by checking mail domain and whitelisted emails
                emailDomain: {
                    message: '^Please use a valid ' + this.appProperties.mailDomain.split(";") + ' email address',
                    domains: this.appProperties.mailDomain.split(";"),
                    whitelistedEmails: [...this.props.whitelist],
                }
            })
        },
        firstName: {
            presence: {
                allowEmpty: false,
                message: '^Please enter your first name'
            },
            length: { minimum: 1 }
        },
        lastName: {
            presence: {
                allowEmpty: false,
                message: '^Please enter your last name'
            },
            length: { minimum: 1 }
        },
        password1: {
            presence: {
                allowEmpty: false,
                message: '^Please enter a password'
            },
            passwordComplexity: {
                minLength: 8,
            }
        },
        password2: {
            presence: {
                allowEmpty: false,
                message: '^Please enter a password'
            },
            equality: {
                attribute: "password1",
                message: "^Password's do not match!",
            },
            passwordComplexity: {
                minLength: 8,
                message: 'Must be at least 8 characters long and should contain a number, an upper case alphabet, a lower case alphabet and a special character',
            }
        },
        confirmationEmailID: {
            presence: {
                allowEmpty: false,
                message: '^Please enter email ID'
            },
            email: true,
            equality: {
                attribute: "emailID",
                message: "^Emaild IDs does not match!",
            }
        },
    }


    getWhiteListFromServer = () => {
        const response = this.props.apiService({
            method: 'get',
            url: '/whitelist',
        });
        response.then(res => {
            if (res.data.message !== null && res.data.message !== '') {
                reject(res.data.message);
            }
            else {
                let whitelist = res.data.data;
                this.setState({
                    whitelistedEmails: whitelist,
                })
            }
        })
    }

    handleTabChange = (_, val) => {
        this.setState({
            tab: val,
            message: this.defaultMessage,
            loading: false,
            // Password Login states
            emailID: '',
            password: '',

            // One Time Code States
            code: '',
            haveCode: false,
            registeredCode:false,

            // Register states
            firstName: '',
            lastName: '',
            password1: '',
            password2: '',
            confirmationEmailID: '',
            passwordLoginFieldErrors: null,
            requestCodeFieldErrors: null,
            registerFieldErrors: null,

            showPassword: false,
            showPassword1: false,
            showPassword2: false,
        })
    }

    validatePassword = (password) => {
        const minLength = password.length >= 8;
        const hasNumber = /\d/.test(password);
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);

        // remove textbox error if password is valid
        if (minLength && hasNumber && hasUpperCase && hasLowerCase && hasSpecialChar) {
            this.setState({
                registerFieldErrors: {
                    ...this.state.registerFieldErrors,
                    password1: null
                }
            })
        }
    
        this.setState({
            passwordConditions: {
                minLength,
                hasNumber,
                hasUpperCase,
                hasLowerCase,
                hasSpecialChar,
            },
        });
    }

    checkPasswordMatch = (password1, password2) => {
        const isPasswordMatching = password1 === password2 && password1 !== "" && password2 !== "";

        this.setState({
            passwordMatching: isPasswordMatching,
        });

        // remove textbox error if password is matching
        if (isPasswordMatching) {
            this.setState({
                registerFieldErrors: {
                    ...this.state.registerFieldErrors,
                    password2: null
                }
            })
        }
    };

    handleRegisterInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        });
        if(event.target.name === 'password1'){
            this.validatePassword(event.target.value);
            this.checkPasswordMatch(event.target.value, this.state.password2);
        } else if(event.target.name === 'password2'){
            this.checkPasswordMatch(this.state.password1, event.target.value);
        } else if (event.target.name === 'emailID') {
            // add textbox error if email is invalid
            let schema = this.registerSchema;
            if (this.appProperties.mailDomain !== "any") {
                schema.emailID.emailDomain.whitelistedEmails = this.props.whitelist;
            }
            let errors = validate({ emailID: event.target.value }, schema);
            this.setState({
                registerFieldErrors: {
                    ...this.state.registerFieldErrors,
                    emailID: errors ? errors.emailID : null
                }
            })
        } else if (event.target.name === 'confirmationEmailID') {
            // add textbox error if email is not matching, validate by validate js schema
            let schema = this.registerSchema;
            let errors = validate({ emailID: this.state.emailID, confirmationEmailID: event.target.value }, schema);
            this.setState({
                registerFieldErrors: {
                    ...this.state.registerFieldErrors,
                    confirmationEmailID: errors ? errors.confirmationEmailID : null
                }
            })
        } else {
            // remove textbox error if input is not empty, for firstName and lastName
            if (event.target.value) {
                this.setState({
                    registerFieldErrors: {
                        ...this.state.registerFieldErrors,
                        [event.target.name]: null
                    }
                })
            }
        }
    };

    handleRegisterInputFocus = (event) =>{
        if(event.target.name === 'password1'){
            this.setState({ showPassword1Checklist: true });
        } else if(event.target.name === 'password2'){
            this.setState({ showPassword2Checklist: true });
        }
    }

    // when user leaves the input field, textbox will show error if input is invalid
    handleRegisterInputBlur = (event) => {
        if(event.target.name === 'password1'){
            this.setState({ showPassword1Checklist: false });
            // add textbox error if password is invalid
            if (!this.state.passwordConditions.minLength || !this.state.passwordConditions.hasNumber || !this.state.passwordConditions.hasUpperCase || !this.state.passwordConditions.hasLowerCase || !this.state.passwordConditions.hasSpecialChar) {
                this.setState({
                    registerFieldErrors: {
                        ...this.state.registerFieldErrors,
                        password1: ['Please enter a valid password']
                    }
                })
            }
        } else if(event.target.name === 'password2'){
            this.setState({ showPassword2Checklist: false });
            // add textbox error if password is not matching
            if (this.state.password1 !== event.target.value) {
                this.setState({
                    registerFieldErrors: {
                        ...this.state.registerFieldErrors,
                        password2: ['Password\'s do not match!']
                    }
                })
            }
        }else if (event.target.name === 'emailID') {
            // if email is not valid show text box error
            let schema = this.registerSchema;
            if (this.appProperties.mailDomain !== "any") {
                schema.emailID.emailDomain.whitelistedEmails = this.props.whitelist;
            }
            let errors = validate({ emailID: this.state.emailID }, schema);
            this.setState({
                registerFieldErrors: {
                    ...this.state.registerFieldErrors,
                    emailID: errors ? errors.emailID : null
                }
            })
        } else if (event.target.name === 'confirmationEmailID') {
            // if email is not matching show text box error
            let schema = this.registerSchema;
            let errors = validate({ emailID: this.state.emailID, confirmationEmailID: this.state.confirmationEmailID }, schema);
            this.setState({
                registerFieldErrors: {
                    ...this.state.registerFieldErrors,
                    confirmationEmailID: errors ? errors.confirmationEmailID : null
                }
            })
        } else {
            // add textbox error if input is empty, for firstName and lastName
            if (!event.target.value) {
                this.setState({
                    registerFieldErrors: {
                        ...this.state.registerFieldErrors,
                        [event.target.name]: ['This field is required']
                    }
                })
            }
        }
    }

    hasRegisterErrors = () => {
        const { registerFieldErrors, firstName, lastName, emailID, password1, password2, confirmationEmailID } = this.state;
    
        if (!registerFieldErrors) {
            return true;
        }
    
        const fieldValues = { firstName, lastName, emailID, password1, password2, confirmationEmailID };
        const hasEmptyFields = Object.values(fieldValues).some(value => isInvalid(value));
        const hasFieldErrors = Object.values(registerFieldErrors).some(error => !isInvalid(error));
    
        return hasEmptyFields || hasFieldErrors;
    }

    passwordLoginValidation = (data) => {
        let schema = this.passwordLoginSchema;
        // if all emails not allowed, validate email using schema
        if (this.appProperties.mailDomain !== "any") {
            schema.emailID.emailDomain.whitelistedEmails = this.props.whitelist;
        }
        let errors = validate(data, schema);

        this.setState({
            passwordLoginFieldErrors: errors
        })
        return errors === undefined;
    }

    handlePasswordLogin = () => {
        toast.dismiss();

        let payload = {
            emailID: this.state.emailID,
            password: this.state.password,
        }

        if (!this.passwordLoginValidation(payload)) {
            return
        }

        this.setState({
            loading: true,
            message: this.defaultMessage,
        })

        const response = this.props.apiService({
            method: 'post',
            url: '/login',
            data: payload
        });

        response.then(res => {
            console.debug("res.data", res.data)
            let type = '';
            let msg = '';
            if (res.data && res.data.status === 1 && res.data.message) {
                type = 'error';
                msg = 'Sorry we could not find a match for the entered Username and Password combination in our system.';
            } else {
                type = 'success';
                msg = "You'll be logged in shortly"
                this.appProperties.currentUserData.setUserDetails(res.data.data, this.appProperties.loginType);
                window.location.reload();
            }

            this.setState({
                message: {
                    show: true,
                    type,
                    msg,
                }
            })

        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    requestCodeValidation = (data) => {
        let schema = this.requestCodeSchema;
        // if all emails not allowed, validate email using schema
        if (this.appProperties.mailDomain !== "any") {
            schema.emailID.emailDomain.whitelistedEmails = this.props.whitelist;
        }
        let errors = validate(data, schema);
        console.debug("errors", errors)
        this.setState({
            requestCodeFieldErrors: errors
        })
        return errors === undefined;
    }

    handleRequestOneTimeCode = (fromForgotPassword) => {
        toast.dismiss();
        this.setState({
            passwordLoginFieldErrors: null,
            requestCodeFieldErrors: null,
        })

        let payload = {
            emailID: this.state.emailID,
        }
        if (!this.requestCodeValidation(payload)) {
            return
        }

        this.setState({
            message: this.defaultMessage,
        })

        if (fromForgotPassword) {
            this.setState({
                forgotPasswordLoading: true
            })
        } else {
            this.setState({
                requestLoading: true
            })
        }

        const response = this.props.apiService({
            method: 'post',
            skipErrorHandle: true,
            url: '/sendCode',
            data: payload
        });

        response.then(res => {
            console.debug("res.data", res.data)
            let type = '';
            let msg = '';
            if (res.data && res.data.status === 1 && res.data.message) {
                type = 'error';
                msg = 'We could not find this user in our system. Please check your email or register this user';
            } else {
                type = 'success';
                msg = 'A 6-digit code should be sent to your email address. Please check in spam and quarantine folders too.'
                this.setState({
                    haveCode: true,
                    registeredCode:false
                })
            }
            this.setState({
                message: {
                    show: true,
                    type,
                    msg,
                }
            })
        }).finally(() => {
            this.setState({
                requestLoading: false,
                forgotPasswordLoading: false,
            })
        })
    }

    codeLoginValidation = (data) => {
        let codeLoginSchema = {
            ...this.requestCodeSchema,
            code: {
                presence: {
                    allowEmpty: false,
                    message: '^Please enter the code'
                },
                length: { is: 6, message: '^Please enter a valid code (should be 6 characters)' }
            }
        }

        let schema = codeLoginSchema;
        // if all emails not allowed, validate email using schema
        if (this.appProperties.mailDomain !== "any") {
            schema.emailID.emailDomain.whitelistedEmails = this.props.whitelist;
        }
        let errors = validate(data, schema);

        console.debug("errors", errors)
        this.setState({
            requestCodeFieldErrors: errors
        })
        return errors === undefined;
    }

    handleCodeLogin = () => {

        let payload = {
            emailID: this.state.emailID,
            code: this.state.code,
        }

        this.setState({
            message: this.defaultMessage,
        })

        if (!this.codeLoginValidation(payload)) {
            return
        }

        this.setState({
            loading: true,
        })

        const response = this.props.apiService({
            method: 'post',
            skipErrorHandle: true,
            url: '/verifyCode',
            data: {
                ...payload,
                type: 'activation-code'
            }
        });

        response.then(res => {
            console.debug("res.data", res.data)
            let type = '';
            let msg = '';
            if (res.data && res.data.status === 1 && res.data.message) {
                type = 'error';
                msg = res.data.message;
            } else {
                this.setState({
                    authType: 'login',
                    haveCode: true,
                    tab: 'code',
                })
                type = 'success'
                msg = "You'll be logged in shortly";
                handleLoginToken(res.data.data);
            }
            this.setState({
                message: {
                    show: true,
                    type,
                    msg,
                }
            })
        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    registerValidation = (data) => {

        let schema = this.registerSchema;
        // if all emails not allowed, validate email using schema
        if (this.appProperties.mailDomain !== "any") {
            schema.emailID.emailDomain.whitelistedEmails = this.props.whitelist;
        }
        let errors = validate(data, schema);

        console.debug("errors", errors)
        this.setState({
            registerFieldErrors: errors
        })
        return errors === undefined;
    }

    handleRegister = () => {

        let data = {
            emailID: this.state.emailID,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            password1: this.state.password1,
            password2: this.state.password2,
            confirmationEmailID: this.state.confirmationEmailID,
        }

        if (!this.registerValidation(data)) {
            return
        }

        this.setState({
            loading: true,
            errorMessage: '',
            successMessage: '',
            message: {
                show: false,
                type: "",
                msg: "",
            }
        })

        let payload = {
            emailID: data.emailID,
            firstName: data.firstName,
            lastName: data.lastName,
            password: data.password1,
            userName: data.emailID.substring(0, data.emailID.indexOf("@")),
        }
        console.debug("payload>>??", payload)
        // return
        const response = this.props.apiService({
            method: 'post',
            skipErrorHandle: false,
            url: '/registerUser',
            data: payload,
        });

        response.then(res => {
            console.debug("res.data", res.data)
            let type = '';
            let msg = '';
            if (res.data && res.data.status === 1 && res.data.message) {
                type = 'error';
                if (res.data.message === 'DUPLICATE REGISTRATION') {
                    msg = "Duplicate Registration detected, please request your instructor to activate your account. If you forgot your password, please login with one time code and update your password in your profile page";
                } else if (res.data.message === "Mail Send Error") {
                    msg = `Oops! We've encountered a error at our end.\nPlease report this issue to esbugs@ontoborn.com`;
                } else {
                    msg = res.data.message;
                }
            } else {
                this.setState({
                    authType: 'login',
                    haveCode: true,
                    tab: 'code',
                    registeredCode:true
                });
                type = 'success';
                msg = 'Registration Successful. Please check your email (Spam/Quarantine folder too) to activate and login using your 6 digit code.'
            }
            this.setState({
                message: {
                    show: true,
                    type,
                    msg,
                }
            })
        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    getEmailError = () => {
        let error = "";
        if (this.state.passwordLoginFieldErrors && this.state.passwordLoginFieldErrors['emailID']) {
            error = this.state.passwordLoginFieldErrors['emailID'][0]
        }
        if (this.state.requestCodeFieldErrors && this.state.requestCodeFieldErrors['emailID']) {
            error = this.state.requestCodeFieldErrors['emailID'][0]
        }
        return error;
    }

    render() {

        if (this.state.ltiLoginLoading) {
            return (
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ minHeight: '100vh' }}
                    >
                        <Grid item xs={3}>
                            <Typography variant='h5' color='black'>
                                Logging you in, please wait..
                            </Typography>
                            <div className='d-flex justify-content-center mt-4'>
                                <BeatLoader color={'#bb0000'} size={15} />
                            </div>
                        </Grid>
                </Grid>
            )
        }

        const { tab, passwordLoginFieldErrors, requestCodeFieldErrors, registerFieldErrors, showPassword, showPassword1, showPassword2, passwordConditions, passwordMatching } = this.state;

        return (
            <Container fullWidth className='h-100 position-relative'>
                <Grid container justifyContent={'center'} alignItems={'center'} height={'100%'} gap={isMobile ? 0:5}>
                    <Grid item lg={5} md={5} sm={12}>
                        <Stack spacing={2}>
                            <div className='w-100 text-align-center'>
                                <img src={SFlogo} width={300} alt="Stemfluecny Logo" />
                            </div>
                            {
                                isMobile ? 

                                <div className='d-flex justifyContent-center flex-column text-align-center'>
                                    <Typography className='d-inline' paddingRight={1} fontSize={20} color={'primary'} fontWeight={'500'}>
                                        Welcome.
                                    </Typography>
                                    <Typography className='d-inline mt-2' fontSize={20} fontWeight={500}lineHeight={"24px"}>
                                        Elevate Your STEM Journey!
                                    </Typography>
                                </div>
                                :

                                <div>
                                    <Typography className='d-inline' paddingRight={1} fontSize={20} color={'primary'} fontWeight={'500'}>
                                        Welcome.
                                    </Typography>
                                    <Typography className='d-inline' fontSize={20} fontWeight={500}lineHeight={"24px"}>
                                        Elevate Your STEM Journey!
                                    </Typography>
                                </div>
                                
                            }
                            {
                                isMobile ?
                                    <div class="sfMobLogin-content-wrapper">
                                        <input onChange={()=> this.setState({
                                            showMoreMobile:!this.state.showMoreMobile
                                        })} type="checkbox" id="sfMobLogin-toggle-content" class="sfMobLogin-toggle-input" />
                                        <div class="sfMobLogin-content">
                                        <Typography fontSize={14} lineHeight={"24px"} fontWeight={'300'} >
                                        Welcome to  { " "}
                                        <Typography className='d-inline' fontWeight={500}>
                                        STEM Fluency
                                        </Typography>
                                        , your gateway to mastering essential STEM Skills! This application is tailored to elevate your understanding of fundamental concepts, preparing you for success in university-level physics courses. Dive into interactive modules, assessments, and engaging content designed to enhance your fluency in STEM. Empower your academic journey and unlock your potential with STEM Fluency — where knowledge meets proficiency.
                                        </Typography>
                                        </div>
                                        <div size={'small'} className='ml-10' width={"89px"} height={"20px"} variant='outlined'>
                                        
                                            <label for="sfMobLogin-toggle-content" class="sfMobLogin-toggle-label">
                                            <Typography className='d-inline' paddingRight={1} fontSize={10} color={'primary'} fontWeight={'700'} style={{ border: "2px solid rgba(187, 0, 0, 1)" , borderRadius: "10px",padding: "2px 10px"}}>

                                            {
                                                this.state.showMoreMobile ? 
                                                "Less About SF" :"More About SF"
                                            }
                                            
                                            </Typography>
                                            </label>
                                        </div>
                                        {this.state.authType !== "register" ? 
                                            <Button sx={{ width: "100%", height:"35px"}} 
                                            className='mt-2'
                                            variant='contained' color='primary' onClick={() => {
                                                this.setState({ authType: 'register', message: this.defaultMessage, registerFieldErrors: null, })
                                            }}>Register</Button>
                                        : null}
                                    </div>
                                :

                                <div>

                                <Typography fontSize={14} lineHeight={"24px"} fontWeight={'300'} className={isMobile?"mx-4":""}>
                                    Welcome to STEM Fluency, your gateway to mastering essential STEM Skills! This application is tailored to elevate your understanding of fundamental concepts, preparing you for success in university-level physics courses. Dive into interactive modules, assessments, and engaging content designed to enhance your fluency in STEM. Empower your academic journey and unlock your potential with STEM Fluency — where knowledge meets proficiency.
                                </Typography>
                                <div className='d-flex flex-wrap mt-4'>
                                    <Button sx={{ width: 1/4 ,height:"35px"}} variant='contained' color='primary' onClick={() => {
                                        this.setState({ authType: 'register', message: this.defaultMessage, registerFieldErrors: null, })
                                    }}>Register</Button>
                                    <a className='d-inline-block' href={`${this.appProperties.appURL.replace("student", "cpanel")}`}>
                                        <Button  size={isMobile ? 'small' : 'medium'} className='ml-4' color={'primary'} variant='text' fontWeight={500} fontSize={14}>
                                            <span className='pr-2'>Not a Student?</span>
                                            <span className='font-weight-bold' style={{textDecoration:"underline","text-underline-offset":"3px"}}>Register as Educator </span>
                                            <span className='font-weight-bold' style={{marginLeft:"3px",marginTop:"3px"}}>{" >> "}</span>
                                        </Button>
                                    </a>
                                </div>
                                </div>
                            }
                        </Stack>

                    </Grid>
                    <Grid item lg={6} md={6} sm={12} align={'center'} className={isMobile ? "pb-4 ":""}>

                        {this.state.authType === 'login' &&
                            <Card sx={{ maxWidth: 438, minHeight: 550, boxShadow: ' 0px 4px 20px rgba(187, 0, 0, 0.25)', borderRadius: 4}} className={isMobile?'py-1 position-relative':'px-4 py-2 position-relative'}>
                                {/* <div className='d-flex justify-content-end '>
                                    <a className='d-inline-block' href={`${this.appProperties.appURL.replace("student", "cpanel")}`}>
                                        <Button color={'primary'} variant='text' fontWeight={500} fontSize={14} style={{textDecoration:"underline","text-underline-offset":"3px"}}>Switch to Educators Website</Button>
                                    </a>
                                </div> */}
                                <CardHeader title={
                                    <Typography align='center' fullWidth paddingRight={1} fontSize={32} color={'#bb0000'} fontWeight={'500'}>
                                        Student Login
                                    </Typography>
                                } />
                                <CardContent style={{ paddingBottom: '0px' }}>
                                    <div>
                                        <TextField
                                            value={this.state.emailID}
                                            onChange={event => {
                                                this.setState({
                                                    emailID: event.target.value,
                                                })
                                            }}
                                            error={(
                                                (passwordLoginFieldErrors && passwordLoginFieldErrors['emailID']) ||
                                                (requestCodeFieldErrors && requestCodeFieldErrors['emailID'])
                                            ) ? true : false} 
                                            label="Email"
                                            id="email"
                                            type='email'
                                            autoFocus
                                            fullWidth
                                            required
                                            className='mb-4'
                                            helperText={this.getEmailError()}
                                        />
                                        <TextField
                                            hidden={this.state.haveCode}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={() => this.setState({ showPassword: !showPassword })}
                                                        >
                                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            value={this.state.password}
                                            onChange={event => {
                                                this.setState({
                                                    password: event.target.value,
                                                })
                                            }}
                                            error={(passwordLoginFieldErrors && passwordLoginFieldErrors['password']) ? true : false} label="Password"
                                            type={showPassword ? 'text' : 'password'}
                                            id="password"
                                            autoComplete={'off'}
                                            fullWidth
                                            required
                                            helperText={passwordLoginFieldErrors && passwordLoginFieldErrors['password'] ? passwordLoginFieldErrors['password'][0] : ''}
                                        />
                                        <div className='justify-content-start my-1' style={{
                                            display: this.state.haveCode ? 'none' : 'flex'
                                        }}>
                                            <Button onClick={() => {
                                                if (this.state.forgotPasswordLoading) return;
                                                this.handleRequestOneTimeCode(true)
                                            }} color={'primary'} variant='text' fontWeight={500} fontSize={11} style={{textDecoration:"underline","text-underline-offset":"3px"}} className='my-2'>
                                                {this.state.forgotPasswordLoading ? <CircularProgress  size={24} /> : 'Forgot password? Send One Time Code'}
                                            </Button>
                                        </div>
                                        <TextField
                                            hidden={!this.state.haveCode}
                                            value={this.state.code}
                                            onChange={event => {
                                                this.setState({
                                                    code: event.target.value,
                                                })
                                            }}
                                            error={(requestCodeFieldErrors && requestCodeFieldErrors['code']) ? true : false}
                                            label="Code"
                                            id="code"
                                            type='text'
                                            autoFocus
                                            fullWidth
                                            required
                                            className='mb-4'
                                            helperText={requestCodeFieldErrors && requestCodeFieldErrors['code'] ? requestCodeFieldErrors['code'][0] : ''}
                                        />

                                        <Button
                                            hidden={this.state.haveCode}
                                            className='loadingButton mt-1' variant='contained' color='primary' fullWidth
                                            disabled={this.state.loading}
                                            sx={{
                                                '&:disabled': {
                                                    backgroundColor: '#bb0000',
                                                    color: 'white',
                                                },
                                            }}
                                            onClick={this.handlePasswordLogin}
                                        >
                                            {this.state.loading ? <CircularProgress className='text-white' size={24} /> : 'Login with password'}
                                        </Button>

                                        <Button
                                            hidden={!this.state.haveCode}
                                            className='loadingButton mt-1' variant='contained' color='primary' fullWidth
                                            disabled={this.state.loading}
                                            sx={{
                                                '&:disabled': {
                                                    backgroundColor: '#bb0000',
                                                    color: 'white',
                                                },
                                            }}
                                            onClick={this.handleCodeLogin}
                                        >
                                            {this.state.loading ? <CircularProgress className='text-white' size={24} /> : 'Login with One Time Code'}
                                        </Button>
                                        
                                        <Alert
                                            hidden={!this.state.message.show}
                                            severity={this.state.message.type}
                                            color={this.state.message.type}
                                            fontWeight={500}
                                            fontSize={14}
                                            className='mt-4 text-align-left'>
                                            {this.state.message.msg}
                                        </Alert>
                                        <div className={`d-flex flex-column w-100 mt-4 py-2`} style={{
                                            border: "1px solid #D9D9D9",
                                            borderRadius: '12px',
                                            alignItems: "center",
                                        }}>
                                            <Typography fontWeight='bold' className='py-2'>Alternate Login</Typography>
                                            <Button onClick={() => {
                                                if (this.state.requestLoading) return;
                                                this.handleRequestOneTimeCode(false);
                                            }} style={{width:'200px'}} className='mt-1'>
                                                {this.state.requestLoading ? <CircularProgress  size={24} /> : 'Send One Time Code'}
                                            </Button>
                                            <Button style={{width:'200px'}} className='mt-1'
                                            hidden={this.state.haveCode}
                                                onClick={() => {
                                                    this.setState({
                                                        haveCode: true,
                                                        message: this.defaultMessage,
                                                        code: '',
                                                        requestCodeFieldErrors: null, 
                                                    })
                                                }}
                                            >
                                                I have the code already!
                                            </Button>
                                            <Button style={{width:'200px'}} className='mt-1'
                                                hidden={!this.state.haveCode}
                                                onClick={() => {
                                                    this.setState({
                                                        haveCode: false,
                                                        message: this.defaultMessage,
                                                        code: '',
                                                        requestCodeFieldErrors: null, 
                                                    })
                                                }}
                                            >
                                                Login with password
                                            </Button>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>}
                        {this.state.authType === 'register' &&
                            <Card sx={{ maxWidth: 438,  boxShadow: ' 0px 4px 20px rgba(187, 0, 0, 0.25)', borderRadius: 4}} className={isMobile?'py-1 position-relative':'px-4 py-2 position-relative'}>
                                <CardHeader title={
                                    <Typography align='center' fullWidth paddingRight={1} fontSize={32} color={'#bb0000'} fontWeight={'500'}>
                                        Student Registration
                                    </Typography>
                                } />

                                <CardContent>
                                    <TextField
                                        onChange={this.handleRegisterInputChange}
                                        onFocus={this.handleRegisterInputFocus}
                                        onBlur={this.handleRegisterInputBlur}
                                        id='emailID'
                                        name='emailID'
                                        label="Email"
                                        fullWidth
                                        type='email'
                                        required
                                        className='mb-4'
                                        error={(registerFieldErrors && registerFieldErrors['emailID']) ? true : false}
                                        helperText={registerFieldErrors && registerFieldErrors['emailID'] ? registerFieldErrors['emailID'][0] : ''}
                                    />
                                    <TextField
                                        onChange={this.handleRegisterInputChange}
                                        onFocus={this.handleRegisterInputFocus}
                                        onBlur={this.handleRegisterInputBlur}
                                        id='firstName'
                                        name='firstName'
                                        label="First Name"
                                        fullWidth
                                        required
                                        className='mb-4'
                                        error={(registerFieldErrors && registerFieldErrors['firstName']) ? true : false}
                                        helperText={registerFieldErrors && registerFieldErrors['firstName'] ? registerFieldErrors['firstName'][0] : ''}
                                    />
                                    <TextField
                                        onChange={this.handleRegisterInputChange}
                                        onFocus={this.handleRegisterInputFocus}
                                        onBlur={this.handleRegisterInputBlur}
                                        id='lastName'
                                        name='lastName'
                                        label="Last Name"
                                        fullWidth
                                        required
                                        className='mb-4'
                                        error={(registerFieldErrors && registerFieldErrors['lastName']) ? true : false}
                                        helperText={registerFieldErrors && registerFieldErrors['lastName'] ? registerFieldErrors['lastName'][0] : ''}
                                    />
                                    <div className='sfAuth-password-container'>
                                    <TextField
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => this.setState({ showPassword1: !showPassword1 })}
                                                    >
                                                        {showPassword1 ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        onFocus={this.handleRegisterInputFocus}
                                        onBlur={this.handleRegisterInputBlur}
                                        onChange={this.handleRegisterInputChange}
                                        id='password1'
                                        name='password1'
                                        label="Password"
                                        type={showPassword1 ? 'text' : 'password'}
                                        fullWidth
                                        required
                                        className='mb-4'
                                        error={(registerFieldErrors && registerFieldErrors['password1']) ? true : false}
                                        helperText={registerFieldErrors && registerFieldErrors['password1'] ? registerFieldErrors['password1'][0] : ''}
                                    />
                                    <div className={`sfAuth-password-checklist-container ${this.state.showPassword1Checklist ? 'show' : 'hide'}`}>
                                        <ul className="sfAuth-password-checklist">
                                            <PasswordListItem passwordCondition={passwordConditions.minLength} label="At least 8 characters" />
                                            <PasswordListItem passwordCondition={passwordConditions.hasNumber} label="Contains a number" />
                                            <PasswordListItem passwordCondition={passwordConditions.hasUpperCase} label="Contains an uppercase letter" />
                                            <PasswordListItem passwordCondition={passwordConditions.hasLowerCase} label="Contains a lowercase letter" />
                                            <PasswordListItem passwordCondition={passwordConditions.hasSpecialChar} label="Contains a special character" />
                                        </ul>
                                    </div>
                                    </div>
                                    <div className='sfAuth-password-container'>
                                    <TextField
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => this.setState({ showPassword2: !showPassword2 })}
                                                    >
                                                        {showPassword2 ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        onFocus={this.handleRegisterInputFocus}
                                        onBlur={this.handleRegisterInputBlur}
                                        onChange={event => {
                                            const password = event.target.value;
                                            this.handleRegisterInputChange(event);
                                            this.checkPasswordMatch(this.state.password1, password);
                                        }}
                                        id='password2'
                                        name='password2'
                                        label="Confirm Password"
                                        type={showPassword2 ? 'text' : 'password'}
                                        fullWidth
                                        required
                                        className='mb-4'
                                        error={(registerFieldErrors && registerFieldErrors['password2']) ? true : false}
                                        helperText={registerFieldErrors && registerFieldErrors['password2'] ? registerFieldErrors['password2'][0] : ''}
                                    />
                                    <div className={`sfAuth-password-checklist-container ${this.state.showPassword2Checklist ? 'show' : 'hide'}`}>
                                        <ul className="sfAuth-password-checklist">
                                        <PasswordListItem passwordCondition={passwordMatching} label="Password Match" />
                                        </ul>
                                    </div>
                                    </div>
                                    <TextField
                                        onChange={this.handleRegisterInputChange}
                                        id='confirmationEmailID'
                                        name='confirmationEmailID'
                                        label="Confirm Email"
                                        fullWidth
                                        type='email'
                                        required
                                        error={(registerFieldErrors && registerFieldErrors['confirmationEmailID']) ? true : false}
                                        helperText={registerFieldErrors && registerFieldErrors['confirmationEmailID'] ? registerFieldErrors['confirmationEmailID'][0] : ''}
                                        className='mb-4'
                                    />

                                    <Button variant='contained' color='primary' onClick={this.handleRegister} fullWidth
                                        disabled={this.state.loading || this.hasRegisterErrors()}
                                        >
                                        {this.state.loading ? <CircularProgress className='text-white' size={24} /> : 'Register'}
                                    </Button>

                                    <Alert
                                        hidden={!this.state.message.show}
                                        severity={this.state.message.type}
                                        color={this.state.message.type}
                                        fontWeight={500}
                                        fontSize={14}
                                        className='mt-4 text-align-left'>
                                        {this.state.message.msg}
                                    </Alert>

                                    <div className='d-flex justify-content-between w-100 mt-4'>
                                        <div>

                                            <Button onClick={() => {
                                                this.setState({
                                                    authType: 'login', tab: "password", 
                                                    emailID: '',
                                                    password: '',
                                                    code: '', 
                                                    message: this.defaultMessage,
                                                    registerFieldErrors: null,
                                                    passwordLoginFieldErrors: null,
                                                    requestCodeFieldErrors: null,
                                                    showPassword: false,
                                                    showPassword1: false,
                                                    showPassword2: false,
                                                })
                                            }} color={'primary'} variant='text' fontWeight={500} fontSize={14}>I have an account</Button>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>}
                    </Grid>
                </Grid>

            </Container>
        )
    }
}


export default SFAuth;